export default __webpack_public_path__ + "static/media/posjobs.bc444c33.jpg";